import { render } from "./internalServiceRequests.vue?vue&type=template&id=28b01dde&scoped=true&ts=true"
import script from "./internalServiceRequests.vue?vue&type=script&lang=ts"
export * from "./internalServiceRequests.vue?vue&type=script&lang=ts"

import "./internalServiceRequests.vue?vue&type=style&index=0&id=28b01dde&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b01dde"]])

export default __exports__